const _ = require('lodash');

exports.getDiffInObj = (object, base) => {
	function changes(object, base) {
		return _.transform(object, function(result, value, key) {
			if (!_.isEqual(value, base[key])) {
				result[key] =
					_.isObject(value) && _.isObject(base[key])
						? changes(value, base[key])
						: value;
			}
		});
	}
	return changes(object, base);
};

exports.createQueryFromObject = obj => {
	const query = Object.keys(obj).map(ob => {
		return `${ob}=${obj[ob]}`;
	});

	return query.join('&');
};

exports.convertQueryToObj = query => {
	const params = query.split('&');
	const res = {};
	params.forEach(param => {
		const p = param.split('=');

		res[p[0]] = p[1];
	});

	return res;
};
